import { render, staticRenderFns } from "./MakePronunciation.vue?vue&type=template&id=02343e8f&scoped=true"
import script from "./MakePronunciation.vue?vue&type=script&lang=js"
export * from "./MakePronunciation.vue?vue&type=script&lang=js"
import style0 from "./MakePronunciation.vue?vue&type=style&index=0&id=02343e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02343e8f",
  null
  
)

export default component.exports